import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { FiChevronRight } from "react-icons/fi";
import ImageUploading from "react-images-uploading";
import { useHistory } from "react-router-dom";

import Image from "../../base/features/micro/Image";
import SimpleLabel from "../../base/features/micro/SimpleLabel";
import { navigate_to_profile } from "../../navigator/user/profile";
import { deleteProfileImage, editProfile, profileDetail } from "./services";

const EditProfile = (props) => {
  const [state, setState] = useState({
    first_name: props.location.state && props.location.state.user.first_name,
    last_name: props.location.state && props.location.state.user.last_name,
    image: props.location.state && props.location.state.user.image,
    images: [],
    pending: false,
    isVerify: false,
  });
  const history = useHistory();

  const get_profile_detail = () => {
    profileDetail().then((items) => {
      items &&
        setState({
          ...state,
          image: items.image,
          first_name: items.first_name,
          last_name: items.last_name,
          isVerify: items.is_verify,
        });
    });
  };

  const edit_profile = () => {
    setState({ ...state, pending: true });
    const formData = new FormData();
    formData.append("first_name", state.first_name);
    formData.append("last_name", state.last_name);
    if (state.images.length > 0) {
      formData.append("image", state.images[0].file);
    }
    editProfile(formData).then(() => {
      setState({ ...state, pending: false });
      if (window.location.search?.includes("_next")) {
        history.push(window.location.search.split("_next=")[1]);
      } else {
        window.location.href = navigate_to_profile();
      }
    });
  };

  const delete_profile_image = () => {
    deleteProfileImage().then((status) => {
      if (status === 200 || status === 204) {
        setState({ ...state, image: null, images: [] });
      }
    });
  };

  useEffect(() => {
    get_profile_detail();
  }, []);

  return (
    <div>
      <header className="row mx-0 px-4 py-3 shadow-sm">
        <div className="col-auto px-0 align-self-center">
          <FiChevronRight
            onClick={() => history.push(navigate_to_profile())}
            className="ms-2"
            size="30"
          />
        </div>
        <div className="col align-self-center text-center px-0">
          <h1 className="fs-5 fw-bold mb-0">اطلاعات کاربری</h1>
        </div>
      </header>
      <body className="px-4 mt-5">
        <div className="row mx-0 px-0">
          <div className="col-12 text-center">
            <div
              className="bg-light-gray rounded-circle d-inline-block p-3 position-relative"
              style={{ width: "100px", height: "100px" }}
            >
              <Image
                imageAlt={"avatar"}
                imageUri={
                  state.images.length > 0
                    ? state.images[0].data_url
                    : state.image && state.image
                }
                isProfile={true}
                imgClassName={"rounded-circle img-cover w-100 h-100"}
                extraClassName={"p-0 img-contain rounded-0 w-100 h-100"}
              />

              <ImageUploading
                multiple={false}
                value={state.images}
                onChange={(imageList, addUpdateIndex) =>
                  setState({ ...state, images: imageList })
                }
                maxNumber={1}
                dataURLKey="data_url"
              >
                {({
                  imageList,
                  onImageUpload,
                  onImageRemoveAll,
                  onImageUpdate,
                  onImageRemove,
                  isDragging,
                  dragProps,
                }) => (
                  <div
                    onClick={onImageUpload}
                    className="bg-white rounded-circle d-inline-block position-absolute shadow-sm"
                    style={{
                      width: "35px",
                      height: "35px",
                      padding: "7px",
                      bottom: "10px",
                      right: "15px",
                    }}
                  >
                    <img
                      alt="camera"
                      src={require("./icons/camera.svg").default}
                      className="w-100 h-100"
                    />
                  </div>
                )}
              </ImageUploading>
            </div>
            <p
              className="fs-6 color-main mt-4 fw-bold"
              onClick={() => delete_profile_image()}
            >
              حذف تصویر
            </p>
          </div>
          <div className="col-12">
            <div className="position-relative">
              <input
                value={state.first_name}
                onChange={(e) =>
                  setState({ ...state, first_name: e.target.value })
                }
                disabled={state.isVerify === true}
                placeholder="نام*"
                className="form-control border rounded14 w-100 px-3 py-2-3"
              />
              {state.first_name && <SimpleLabel text="نام*" />}
            </div>
          </div>
          <div className="col-12 mt-3">
            <div className="position-relative">
              <input
                value={state.last_name}
                placeholder="نام خانوادگی"
                disabled={state.isVerify === true}
                onChange={(e) =>
                  setState({ ...state, last_name: e.target.value })
                }
                className="form-control border rounded14 w-100 px-3 py-2-3"
              />
              {state.last_name && <SimpleLabel text="نام خانوادگی" />}
            </div>
          </div>
          <div className="col-12 mt-4">
            <button
              disabled={!state.first_name}
              className="btn w-100 rounded28 fs-6 px-3 py-2-3 bg-color-main text-white fw-bolder"
              onClick={() => state.first_name && edit_profile()}
            >
              {state.pending ? (
                <span className="spinner-border spinner-border-sm text-white align-middle"></span>
              ) : (
                "ذخیره"
              )}
            </button>
          </div>
        </div>
      </body>
    </div>
  );
};

export default EditProfile;
